import { useState } from 'react';
import { slugifyOrganisationName } from './slugifyOrganisationName';

/**
 * Name + slug fields where the slug auto-follows the name until the user
 * edits the slug manually (standard create-tenant UX).
 */
export function useOrganisationSlugFields() {
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [slugTouched, setSlugTouched] = useState(false);

  const onNameChange = (next: string) => {
    setName(next);
    if (!slugTouched) setSlug(slugifyOrganisationName(next));
  };

  const onSlugChange = (next: string) => {
    setSlugTouched(true);
    setSlug(next.toLowerCase());
  };

  return {
    name,
    slug,
    onNameChange,
    onSlugChange,
  };
}
